module.exports = "/assets/data/ea37c11bf5412eb410af12853374806f-B4.data.json";